import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
    selector   : 'app-numeric-percent',
    templateUrl: './numeric-percent.component.html',
    styleUrls  : ['./numeric-percent.component.scss']
})
export class AppNumericPercentComponent
{
    @Output() number: EventEmitter<number> = new EventEmitter<number>();
    @Input() value = 0;
    @Input() error = false;

    @Input() ok = false;

    total = 0;
    constructor()
    {

    }

    numUpdown(say: number) {
        this.number.emit(say);
    }

    plus(){

        this.total = this.value;
        if ( this.total >= 0) {
            this.total++;
        }
        this.number.emit(this.total);
    }
    less(){
        this.total = this.value;
        if ( this.total > 0) {
            this.total--;
        }else{
            this.total = 0;
        }
        this.number.emit(this.total);
    }

}
